import * as React from 'react';
import Grid from '@mui/material/Grid';
import CancelIcon from '@mui/icons-material/Cancel';
import IconButton from '@mui/material/IconButton';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Typography from '@mui/material/Typography';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import moment from "moment";
import { useState, useEffect } from 'react';
import AssessmentIcon from '@mui/icons-material/Assessment';

interface IDateRangeChipProps {
    filterNames: string[],
    onSelect: (filterName: string, value: any) => void,
    title: string,
    currentStart: Date,
    currentEnd: Date,
    show: boolean,
    removeFilter?: (filter: string, names: string[]) => void;
    filterFlag: string;
    isAgent: boolean;
    showOnReport?: boolean;
}

export default function DateRangeChip(props: IDateRangeChipProps) {
    const [minDateLimit, setMinDateLimit] = useState<any>(moment());
    const [maxDateLimit, setMaxDateLimit] = useState<any>(moment());


    useEffect(() => {
        let minDate = moment().subtract(1, "month");
        minDate = minDate.set("date", 1);
        setMinDateLimit(minDate);
        const maxDate = moment().subtract(1, "day");
        setMaxDateLimit(maxDate);
    }, [])

    const handleSelect = (name: any, value: any) => {
        props.onSelect(name, value);
    }
    const handleDelete = () => {
        if (props.removeFilter !== null && props.removeFilter !== undefined) {
            props.removeFilter(props.filterFlag, props.filterNames);
        }
    }

    const showRemove = props.removeFilter !== null && props.removeFilter !== undefined ?
        <IconButton title="Remove" aria-label="Remove" onClick={handleDelete} sx={{ padding: 0, margin: '4px' }}><CancelIcon /></IconButton> : <React.Fragment />;

    return (
        <LocalizationProvider dateAdapter={AdapterMoment}>
            <>
                {props.show &&
                    <Grid>
                        <Grid container sx={{ minHeight: '32px', backgroundColor: '#e0e0e0', borderRadius: '16px', }} justifyContent="space-between" alignItems="center">
                            {props.showOnReport &&
                                <AssessmentIcon sx={{ ml: 1 }} />
                            }
                            <Grid sx={{ padding: '0 12px' }}>
                                <Typography variant="body1">{props.title}</Typography>
                            </Grid>
                            {props.isAgent ?
                                <DatePicker onChange={(newDate: moment.Moment | null) => handleSelect(props.filterNames[0], newDate)} format={"DD/MM/YYYY"} sx={{ border: 'none', "& fieldset": { border: 'none' }, maxHeight: '32px', bottom: '12px', maxWidth: '168px' }} value={moment(props.currentStart)} maxDate={maxDateLimit} minDate={minDateLimit} slotProps={{
                                    textField: {
                                        inputProps: { readOnly: true },
                                    },
                                }} />
                                :
                                <DatePicker onChange={(newDate: moment.Moment | null) => handleSelect(props.filterNames[0], newDate)} maxDate={maxDateLimit} format={"DD/MM/YYYY"} sx={{ border: 'none', "& fieldset": { border: 'none' }, maxHeight: '32px', bottom: '12px', maxWidth: '168px' }} value={moment(props.currentStart)} slotProps={{
                                    textField: {
                                        inputProps: { readOnly: true },
                                    },
                                }} />
                            }
                            <Grid style={{ padding: '0 8px' }}>
                                <Typography variant="body1">to</Typography>
                            </Grid>
                            {props.isAgent ?
                                <DatePicker onChange={(newDate: moment.Moment | null) => handleSelect(props.filterNames[1], newDate)} format={"DD/MM/YYYY"} sx={{ border: 'none', "& fieldset": { border: 'none' }, maxHeight: '32px', bottom: '12px', maxWidth: '168px' }} value={moment(props.currentEnd)} maxDate={maxDateLimit} minDate={minDateLimit} slotProps={{
                                    textField: {
                                        inputProps: { readOnly: true },
                                    },
                                }} />
                                :
                                <DatePicker onChange={(newDate: moment.Moment | null) => handleSelect(props.filterNames[1], newDate)} maxDate={maxDateLimit} format={"DD/MM/YYYY"} sx={{ border: 'none', "& fieldset": { border: 'none' }, maxHeight: '32px', bottom: '12px', maxWidth: '168px' }} value={moment(props.currentEnd)} slotProps={{
                                    textField: {
                                        inputProps: { readOnly: true },
                                    },
                                }} />
                            }
                            <Grid>
                                {showRemove}
                            </Grid>
                        </Grid>
                    </Grid>
                }
            </>
        </LocalizationProvider>

    );
}
